import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class OmContainer extends TrackableEntity {
    id: number = 0;
    mblId: number = 0;
    containerNo: string = '';
    conType: string = '';
    sealNo: string = '';
    sealNo2: string = '';
    sealNo3: string = '';
    pkgs: number = 0;
    pUnit: string = '';
    kgs: number = 0;
    lbs: number = 0;
    gKgs: number = 0;
    gLbs: number = 0;
    netKgs: number = 0;
    cbm: number = 0;
    goDate: string | null = null;
    lastFreeDay: string | null = null;
    pickupNo: string = '';
    pickupLoc: string = '';
    inDate: string | null = null;
    outDate: string | null = null;
    emptyReturn: string | null = null;
    ord: string | null = null;
    loadDate: string | null = null;
    atd: string | null = null;
    ata: string | null = null;
    unloadDate: string | null = null;
    cfsDate: string | null = null;
    rAtd: string | null = null;
    rAta: string | null = null;
    puDate: string | null = null;
    dcDate: string | null = null;
    inDateLoc: string = '';
    outDateLoc: string = '';
    emptyReturnLoc: string = '';
    ordLoc: string = '';
    loadDateLoc: string = '';
    atdLoc: string = '';
    ataLoc: string = '';
    unloadDateLoc: string = '';
    cfsDateLoc: string = '';
    rAtdLoc: string = '';
    rAtaLoc: string = '';
    puDateLoc: string = '';
    dcDateLoc: string = '';
    carrierRls: string | null = null;
    bookingDate: string | null = null;
    customRls: string | null = null;
    carrierRlsLoc: string = '';
    bookingLoc: string = '';
    customRlsLoc: string = '';
    amsLinkUserID: string = '';
    amsLinkId: number = 0;
    amsLinkDate: string | null = null;
    pimsLinkUserId: string = '';
    pimsLinkId: number = 0;
    pimsLinkDate: string | null = null;
    order: number = 0;
    isFlexiTank: boolean = false;
    tankSize: string = '';
    fitBy: string = '';
    fitByDate: string | null = null;
    commodity: string = '';
    loadAmount: number = 0;
    puNo: string = '';
    ftLoadDate: string | null = null;
    ftLoadDay: string | null = null;
    ftLoadTime: string | null = null;
    gallon: number = 0;
    hts: string = '';
    payload: number = 0;
    capacity: number = 0;
    serialNo: string = '';
    flexiAction: string = '';
    hasHblLink: boolean = false;
    oimBlId: number = 0;

    // UI
    select: boolean = false;

    constructor(init?:Partial<OmContainer>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('flexiAction', 'hasHblLink', 'oimBlId');
        if(this.id === 0) this.id = this.GetNextId();
    }

    // Called from View to make SQLList by passing arg
    getDbMappings(isImport:any):IDictionary<DBMappingInfo> {
        if(typeof isImport !== 'boolean'){
            isImport = isImport === 'oimContainerList';
        }
        return OmContainer.getFieldMappings(isImport);
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'tankSize': new DBMappingInfo({ field: 'F_TANKSIZE', table: 'T_OOMCONTAINER' }),
        'fitByDate': new DBMappingInfo({ field: 'F_FITBYDATE', table: 'T_OOMCONTAINER' }),
        'commodity': new DBMappingInfo({ field: 'F_COMMODITY', table: 'T_OOMCONTAINER' }),
        'payload': new DBMappingInfo({ field: 'F_PAYLOAD', table: 'T_OOMCONTAINER' }),
        'capacity': new DBMappingInfo({ field: 'F_CAPACITY', table: 'T_OOMCONTAINER' }),
        'puNo': new DBMappingInfo({ field: 'F_PUNO', table: 'T_OOMCONTAINER' }),
        'ftLoadDate': new DBMappingInfo({ field: 'F_FTLOADDATE', table: 'T_OOMCONTAINER' }),
        'containerNo': new DBMappingInfo({ field: 'F_CONTAINERNO', table: 'T_OOMCONTAINER' }),
        'conType': new DBMappingInfo({ field: 'F_CONTYPE', table: 'T_OOMCONTAINER' }),
        'sealNo': new DBMappingInfo({ field: 'F_SEALNO', table: 'T_OOMCONTAINER' }),
        'pkgs': new DBMappingInfo({ field: 'F_PKGS', table: 'T_OOMCONTAINER' }),
        'pUnit': new DBMappingInfo({ field: 'F_UNIT', table: 'T_OOMCONTAINER' }),
        'sealNo2': new DBMappingInfo({ field: 'F_SEALNO2', table: 'T_OOMCONTAINER' }),
        'sealNo3': new DBMappingInfo({ field: 'F_SEALNO3', table: 'T_OOMCONTAINER' }),
        'serialNo': new DBMappingInfo({ field: 'F_SERIALNO', table: 'T_OOMCONTAINER' }),
        'netKgs': new DBMappingInfo({ field: 'F_NETKGS', table: 'T_OOMCONTAINER' }),
        'gKgs': new DBMappingInfo({ field: 'F_GROSSKGS', table: 'T_OOMCONTAINER' }),
        'gLbs': new DBMappingInfo({ field: 'F_GROSSLBS', table: 'T_OOMCONTAINER' }),
        'cbm': new DBMappingInfo({ field: 'F_CBM', table: 'T_OOMCONTAINER' }),
        'gallon': new DBMappingInfo({ field: 'F_GALLON', table: 'T_OOMCONTAINER' }),
        'hts': new DBMappingInfo({ field: 'F_HTS', table: 'T_OOMCONTAINER' }),
        'isFlexiTank': new DBMappingInfo({ field: 'F_ISFLEXITANK', table: 'T_OOMCONTAINER' }),
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_OOMCONTAINER' }),
        'mblId': new DBMappingInfo({ field: 'f_oomblid', table: 'T_OOMCONTAINER' }),
        'bookingDate': new DBMappingInfo({ field: 'f_bookingdate', table: 'T_OOMCONTAINER' }),
        'bookingLoc': new DBMappingInfo({ field: 'f_booking_loc', table: 'T_OOMCONTAINER' }),
        'ord': new DBMappingInfo({ field: 'f_ord', table: 'T_OOMCONTAINER' }),
        'ordLoc': new DBMappingInfo({ field: 'f_ord_loc', table: 'T_OOMCONTAINER' }),
        'inDate': new DBMappingInfo({ field: 'f_indate', table: 'T_OOMCONTAINER' }),
        'inDateLoc': new DBMappingInfo({ field: 'f_indate_loc', table: 'T_OOMCONTAINER' }),
        'loadDate': new DBMappingInfo({ field: 'f_loaddate', table: 'T_OOMCONTAINER' }),
        'loadDateLoc': new DBMappingInfo({ field: 'f_loaddate_loc', table: 'T_OOMCONTAINER' }),
        'atd': new DBMappingInfo({ field: 'f_atd', table: 'T_OOMCONTAINER' }),
        'atdLoc': new DBMappingInfo({ field: 'f_atd_loc', table: 'T_OOMCONTAINER' }),
        'ata': new DBMappingInfo({ field: 'f_ata', table: 'T_OOMCONTAINER' }),
        'ataLoc': new DBMappingInfo({ field: 'f_ata_loc', table: 'T_OOMCONTAINER' }),
        'unloadDate': new DBMappingInfo({ field: 'f_unloaddate', table: 'T_OOMCONTAINER' }),
        'unloadDateLoc': new DBMappingInfo({ field: 'f_unloaddate_loc', table: 'T_OOMCONTAINER' }),
        'puDate': new DBMappingInfo({ field: 'f_pudate', table: 'T_OOMCONTAINER' }),
        'puDateLoc': new DBMappingInfo({ field: 'f_pudate_loc', table: 'T_OOMCONTAINER' }),
        'dcDate': new DBMappingInfo({ field: 'f_dcdate', table: 'T_OOMCONTAINER' }),
        'dcDateLoc': new DBMappingInfo({ field: 'f_dcdate_loc', table: 'T_OOMCONTAINER' }),

    };

    static dicFieldMappings4Import:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_OIMCONTAINER' }),
        'mblId': new DBMappingInfo({ field: 'F_OIMBLId', table: 'T_OIMCONTAINER' }),
        'containerNo': new DBMappingInfo({ field: 'F_ContainerNo', table: 'T_OIMCONTAINER' }),
        'conType': new DBMappingInfo({ field: 'F_ConType', table: 'T_OIMCONTAINER' }),
        'sealNo': new DBMappingInfo({ field: 'F_SealNo', table: 'T_OIMCONTAINER' }),
        'lastFreeDay': new DBMappingInfo({ field: 'F_LastFreeDay', table: 'T_OIMCONTAINER' }),
        'goDate': new DBMappingInfo({ field: 'F_GODate', table: 'T_OIMCONTAINER' }),
        'pickupNo': new DBMappingInfo({ field: 'F_PickupNo', table: 'T_OIMCONTAINER' }),
        'pickupLoc': new DBMappingInfo({ field: 'F_PickupLoc', table: 'T_OIMCONTAINER' }),
        'emptyReturn': new DBMappingInfo({ field: 'F_EmptyReturn', table: 'T_OIMCONTAINER' }),
        'pkgs': new DBMappingInfo({ field: 'F_Pkgs', table: 'T_OIMCONTAINER' }),
        'kgs': new DBMappingInfo({ field: 'F_KGS', table: 'T_OIMCONTAINER' }),
        'lbs': new DBMappingInfo({ field: 'F_LBS', table: 'T_OIMCONTAINER' }),
        'inDate': new DBMappingInfo({ field: 'F_InDate', table: 'T_OIMCONTAINER' }),
        'outDate': new DBMappingInfo({ field: 'F_OutDate', table: 'T_OIMCONTAINER' }),
        //'pUnit': new DBMappingInfo({ field: 'F_UNIT', table: 'T_OIMCONTAINER' }),
        'bookingDate': new DBMappingInfo({ field: 'f_bookingdate', table: 'T_OIMCONTAINER' }),
        'bookingLoc': new DBMappingInfo({ field: 'f_booking_loc', table: 'T_OIMCONTAINER' }),
        'ord': new DBMappingInfo({ field: 'f_ord', table: 'T_OIMCONTAINER' }),
        'ordLoc': new DBMappingInfo({ field: 'f_ord_loc', table: 'T_OIMCONTAINER' }),
        'inDateLoc': new DBMappingInfo({ field: 'f_indate_loc', table: 'T_OIMCONTAINER' }),
        'loadDate': new DBMappingInfo({ field: 'f_loaddate', table: 'T_OIMCONTAINER' }),
        'loadDateLoc': new DBMappingInfo({ field: 'f_loaddate_loc', table: 'T_OIMCONTAINER' }),
        'atd': new DBMappingInfo({ field: 'f_atd', table: 'T_OIMCONTAINER' }),
        'atdLoc': new DBMappingInfo({ field: 'f_atd_loc', table: 'T_OIMCONTAINER' }),
        'carrierRls': new DBMappingInfo({ field: 'f_carrierrls', table: 'T_OIMCONTAINER' }),
        'carrierRlsLoc': new DBMappingInfo({ field: 'f_carrierrls_loc', table: 'T_OIMCONTAINER' }),
        'customRls': new DBMappingInfo({ field: 'f_customrls', table: 'T_OIMCONTAINER' }),
        'customRlsLoc': new DBMappingInfo({ field: 'f_customrls_loc', table: 'T_OIMCONTAINER' }),
        'ata': new DBMappingInfo({ field: 'f_ata', table: 'T_OIMCONTAINER' }),
        'ataLoc': new DBMappingInfo({ field: 'f_ata_loc', table: 'T_OIMCONTAINER' }),
        'unloadDate': new DBMappingInfo({ field: 'f_unloaddate', table: 'T_OIMCONTAINER' }),
        'unloadDateLoc': new DBMappingInfo({ field: 'f_unloaddate_loc', table: 'T_OIMCONTAINER' }),
        'cfsDate': new DBMappingInfo({ field: 'f_cfsdate', table: 'T_OIMCONTAINER' }),
        'cfsDateLoc': new DBMappingInfo({ field: 'f_cfsdate_loc', table: 'T_OIMCONTAINER' }),
        'rAtd': new DBMappingInfo({ field: 'f_ratd', table: 'T_OIMCONTAINER' }),
        'rAtdLoc': new DBMappingInfo({ field: 'f_ratd_loc', table: 'T_OIMCONTAINER' }),
        'rAta': new DBMappingInfo({ field: 'f_rata', table: 'T_OIMCONTAINER' }),
        'rAtaLoc': new DBMappingInfo({ field: 'f_rata_loc', table: 'T_OIMCONTAINER' }),
        'puDate': new DBMappingInfo({ field: 'f_pudate', table: 'T_OIMCONTAINER' }),
        'puDateLoc': new DBMappingInfo({ field: 'f_pudate_loc', table: 'T_OIMCONTAINER' }),
        'outDateLoc': new DBMappingInfo({ field: 'f_outdate_loc', table: 'T_OIMCONTAINER' }),
        'dcDate': new DBMappingInfo({ field: 'f_dcdate', table: 'T_OIMCONTAINER' }),
        'dcDateLoc': new DBMappingInfo({ field: 'f_dcdate_loc', table: 'T_OIMCONTAINER' }),
        'emptyReturnLoc': new DBMappingInfo({ field: 'f_emptyreturn_loc', table: 'T_OIMCONTAINER' }),

    };

    static getFieldMappings = (isImport:boolean):IDictionary<DBMappingInfo> => {
        return isImport ? this.dicFieldMappings4Import : this.dicFieldMappings;
    };

}
